<div class="group relative">
  <label
    [attr.for]="'productSearch'"
    class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
    {{ label() }}
  </label>

  <div class="relative">
    <input
      type="text"
      [id]="'productSearch'"
      [(ngModel)]="searchTerm"
      class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] transition-all outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pl-10 rtl:pr-10"
      [placeholder]="placeholder()"
      [class.border-red-500]="isInvalid()" />

    <svg
      class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 ltr:left-3 rtl:right-3"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  </div>
</div>
